import AmenitySection from "@Pages/PropertyPage/components/AmenitiesSection/components/AmenitySection";
import Tag from "@Pages/PropertyPage/components/AmenitiesSection/components/Tag";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./AmenitiesStyles.module.scss";

const Amenities = ({ features, isDesktop }: any) => {
  const featuresData = features?.filter((f: any) => f?.values?.length > 0) || [];
  const { t } = useTranslationHook();

  if (isDesktop) {
    return (
      <>
        {featuresData.map((feature: any, index: number) => (
          <AmenitySection
            title={feature.name}
            amenityList={feature.values}
            withDivider={index < featuresData.length - 1}
            key={feature.name}
            roomTypeSection
            isDesktop={isDesktop}
            showMore
          />
        ))}
      </>
    );
  }

  return (
    <div className={styles.groupedContainer}>
      <h4 className={styles.mainHeader}>{t("propertypage.amenitiessection.amenitiestitle")}</h4>
      <div className={styles.contentWrapper}>
        {featuresData.map((feature: any, index: number) => (
          <div key={feature.name}>
            <div className={styles.categorySection}>
              <div className={styles.categoryTitle}>{t(feature.name)}</div>
              <div className={styles.tagsContainer}>
                {feature.values.map((amenity: any, idx: number) => {
                  const amenityType = `${amenity.name_en ? amenity.name_en : amenity.name} ${
                    amenity.type
                  }`;
                  return (
                    <Tag
                      key={`${amenity.name}-${idx}`}
                      icon={amenityType}
                      value={amenity.name}
                      roomTypeSection
                      isDesktop={isDesktop}
                    />
                  );
                })}
              </div>
            </div>
            {index < featuresData.length - 1 && <div className={styles.dashedDivider} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default wrapperHOC(Amenities, {
  componentName: "Amenities-ViewMoreDetailsModal-RoomTypeCard-PropertyPage",
  showForChina: true,
});
